import {IconButton, Tooltip} from "@material-ui/core";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import React, {FC, useState} from "react";
import CopyIcon from "view/images/CopyIcon";

import {apiV2} from "api/firebase";

type CopyReviewLinkButtonProps = {
  showId?: string;
  taskId?: string;
  standId?: string;
  reviewerEmail: string;
};

/**
 * Copies an anonymous review magic-link for a specific email reviewer.
 * Asks the BE to issue (and bind) a fresh key via `issueReviewLink`,
 * then copies the returned URL.
 */
const CopyReviewLinkButton: FC<CopyReviewLinkButtonProps> = ({
  showId,
  taskId,
  standId,
  reviewerEmail,
}) => {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    if (!showId || !taskId || !standId || loading) return;
    setLoading(true);
    try {
      const {magicLinkUrl} = await apiV2.task.issueReviewLink(
        {taskId},
        {showId, standId, reviewerEmail}
      );
      await navigator.clipboard.writeText(magicLinkUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to issue review link", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Copy review link">
      <IconButton onClick={onClick} disabled={loading}>
        {copied ? <CheckCircleOutlinedIcon color="primary" /> : <CopyIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyReviewLinkButton;
